export default "__VITE_ASSET__DnzYHh5H__"